// Promotional copy: Klarna, the premium package banner, the achievement video link, and price rule
// fallbacks. Fields named `…Lead` / `…Emphasis` / `…Tail` are one sentence split around markup.
export const promotionsContent = {
  // Klarna
  klarnaIconAlt: 'Klarna Icon',
  klarnaLogoAlt: 'Klarna',
  klarnaAdHeading: 'Buy Now, Pay Later with Klarna',
  klarnaAdBodyLead:
    'Klarna is a payment platform that helps you discover new products and get what you love, with the flexibility to',
  klarnaAdBodyEmphasis: 'split your purchase into 4 manageable, interest free payments.',
  klarnaBlurbLead: 'Own the moment with 4',
  klarnaBlurbEmphasis: 'interest-free',
  klarnaBlurbTail: 'installments*',
  klarnaLearnMoreLabel: 'Learn More',
  // Followed by the bold per-payment amount
  klarnaPaymentsLead: '4 payments of',

  // Premium package banner
  packageBannerHeading: 'Premium Packages',
  packageBannerUnlimitedPoses: 'Unlimited Poses',
  packageBannerDigitalDownload: 'Digital Image Download',
  packageBannerFreeShipping: 'Free Shipping',
  packageBannerAchievementVideo: 'Achievement Video',

  viewSampleAchievementVideoLabel: 'View Sample Achievement Video',

  // Fills a price rule's `##endDate##` when the rule has no end date
  priceRuleEndDateFallback: 'Soon'
}
